import { CarouselModal, MicrobesOutlineBg } from '@repo/ui';
import useAgreement from 'hooks/agreements/useAgreement';
import { useState } from 'react';
import useImpersonate from 'services/auth/useImpersonate';
import { AgreementKey } from 'types/Agreement';
import styles from './ConditionsEducationalModal.module.css';
import { useConditionsEducationalModal } from './context';
import FinalSlide from './slides/FinalSlide';
import { STATIC_SLIDES } from './slides/staticSlides';

export default function ConditionsEducationalModal() {
  const { impersonateId } = useImpersonate();
  const { reviewOpen, reviewNonce, closeReview } =
    useConditionsEducationalModal();
  const [visible, setVisible] = useState(true);

  const agreement = useAgreement(AgreementKey.NON_DIAGNOSTIC);

  // The mandatory consent gate always wins; a manual re-open only applies once
  // the user has already accepted.
  const gateOpen = visible && !agreement;
  const isReview = reviewOpen && !gateOpen;

  // On re-open the user has already consented, so we drop the checkbox slide
  // and let them dismiss freely.
  const closable = isReview || !!impersonateId;

  function handleClose() {
    if (isReview) closeReview();
    else setVisible(false);
  }

  return (
    <CarouselModal
      key={isReview ? `review-${reviewNonce}` : 'gate'}
      visible={gateOpen || isReview}
      slides={
        isReview
          ? STATIC_SLIDES
          : [...STATIC_SLIDES, <FinalSlide setVisible={setVisible} />]
      }
      background={<MicrobesOutlineBg />}
      modalContentClassName={styles.modalContent}
      onClose={closable ? handleClose : undefined}
      enableSwipe
    />
  );
}
